import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const RelatedRulesLink = styled(Link)(({ theme }) => ({
    color: theme.palette.purple.secondary
}));
